import React from 'react';
import {
  Box,
  Typography,
  useTheme,

} from '@mui/material';
import { tokens } from 'theme/tokens';

const ToastHandler = (props) => {
  const { toast, type } = props;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const TOAST_COLORS = {
    INFO: colors.info.main,
    WARNING: colors.warning.main,
    ERROR: colors.error.main,
    SUCCESS: colors.success.main,
    info: colors.info.main,
    warn: colors.warning.main,
    error: colors.error.main,
    success: colors.success.main,
  };

  const getToastColor = (type) =>TOAST_COLORS[type] || colors.info.main;
  return (
    <Box      
      hidden={toast === null || toast.message === undefined}
    >
      <Typography 
        style={{
          background: toast.message === "" ? 'none' : getToastColor(type),
          margin: 'auto',
          textAlign: 'center',
          letterSpacing: '1px',
          color: '#fff',
          padding: '8px',
          width: 'fit-content',
          textTransform: 'capitalize',
          borderRadius: '3px',
        }}
      >
        {toast.message}
      </Typography>
    </Box>
  );
};

export default ToastHandler;
